export const TeamCTI = {
    CSA: {
        csaConfiguration: {
            category: 'NON_FRAMEWORK_ISSUE: CSA Configuration Issue. This is not a real CTI.',
            type: '',
            item: '',
        },
    },
    NoIssue: {
        generalNoIssue: {
            category: 'NON_FRAMEWORK_ISSUE: No Issue. This is not a real CTI.',
            type: '',
            item: '',
        },
    },
    Aura: {
        moduleMediaControlGeneral: {
            category: 'Customer Service',
            type: 'Connect CCP',
            item: 'General Media Control',
        },
        acceptCall: {
            category: 'Customer Service',
            type: 'Connect CCP',
            item: 'Accept Call',
        },
    },
    Sapphire: {
        voiceCallIssues: {
            category: 'Aviary',
            type: 'Framework',
            item: 'Voice Call Issues',
        },
        sessionControlBar: {
            category: 'Aviary',
            type: 'Framework',
            item: 'SessionControlBar',
        },
        moduleInteraction: {
            category: 'Caracara',
            type: 'Caracara Frameworks',
            item: 'Module-Interaction',
        },
        internal: {
            category: 'Customer Service',
            type: 'Internal',
            item: 'CS Sapphire',
        },
    },
    Reach: {
        internal: {
            category: 'Customer Service',
            type: 'Internal',
            item: 'CS Reach',
        },
    },
    Citrine: {
        authLambda: {
            category: 'Customer Service',
            type: 'CSC-UI-Auth',
            item: 'Infrastructure',
        },
        csaAuthIssues: {
            category: 'Aviary',
            type: 'Framework',
            item: 'AC3 Authentication of CSA',
        },
        dataProxy: {
            category: 'Customer Service',
            type: 'CSC-UI-DataProxy',
            item: 'Infrastructure',
        },
    },
    Dexters: {
        structuredEvents: {
            category: 'Caracara',
            type: 'Internal Automated',
            item: 'Dexters'
        }
    },
    Panda: {
        transferDestinationConfiguration: {
            category: 'Customer Service',
            type: 'CS Panda',
            item: 'CSTransferDestinationConfiguration',
        },
        csaDashboard: {
            category: 'Aviary',
            type: 'Contacts',
            item: 'CSA Dashboard RC',
        },
        email: {
            category: 'Caracara',
            type: 'Customer Support Actions',
            item: 'Email Transfer Contact Widget',
        },
        transferFinder: {
            category: 'Aviary',
            type: 'Transfer Finder',
            item: 'Transfer Finder Widget',
        },
        // reusing CTI as CS Panda is not creating new CTI for time being.
        receivingTransfer: {
            category: 'Aviary',
            type: 'Transfer Finder',
            item: 'Transfer Finder Widget',
        },
    },
    CustomerAuthentication: {
        customerNotInActiveConversation: {
            category: 'Customer Service',
            type: 'Customer Authentication',
            item: 'General Inquiry',
        },
    },
    GEPM: {
        configurations: {
            category: 'Customer Service',
            type: 'CS Connect Migration',
            item: 'Configurations',
        },
    },
};
//# sourceMappingURL=TeamCTI.js.map